import {FC, PropsWithChildren} from 'react';
import {User} from 'oidc-client-ts';

import AuthenticationServiceInstance from '@/services/authentication';
import {AuthenticationContext} from './authentication.context';

type Props = PropsWithChildren<{
  user: User;
}>;

export const AuthenticationProvider: FC<Props> = ({children, user}) => {
  return (
    <AuthenticationContext.Provider value={{user, logout: AuthenticationServiceInstance.logout}}>
      {children}
    </AuthenticationContext.Provider>
  );
};
